__turbopack_context__.v({
  "actions": "collection-small-module__m8aW-q__actions",
  "aside": "collection-small-module__m8aW-q__aside",
  "copy": "collection-small-module__m8aW-q__copy",
  "description": "collection-small-module__m8aW-q__description",
  "descriptionDesktop": "collection-small-module__m8aW-q__descriptionDesktop",
  "descriptionMobile": "collection-small-module__m8aW-q__descriptionMobile",
  "descriptionSlot": "collection-small-module__m8aW-q__descriptionSlot",
  "divider": "collection-small-module__m8aW-q__divider",
  "grid": "collection-small-module__m8aW-q__grid",
  "media": "collection-small-module__m8aW-q__media",
  "photo": "collection-small-module__m8aW-q__photo",
  "pill": "collection-small-module__m8aW-q__pill",
  "section": "collection-small-module__m8aW-q__section",
  "slide": "collection-small-module__m8aW-q__slide",
  "slideImage": "collection-small-module__m8aW-q__slideImage",
  "slides": "collection-small-module__m8aW-q__slides",
  "title": "collection-small-module__m8aW-q__title",
});
